// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsFundsHoldingsOverviewModule } from './app.module';
bootstrapAppModule(MutualFundsFundsHoldingsOverviewModule);
